import { render, staticRenderFns } from "./AddManagementPolicy.vue?vue&type=template&id=3a54c59d&scoped=true&"
import script from "./AddManagementPolicy.vue?vue&type=script&lang=js&"
export * from "./AddManagementPolicy.vue?vue&type=script&lang=js&"
import style0 from "./AddManagementPolicy.vue?vue&type=style&index=0&id=3a54c59d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a54c59d",
  null
  
)

export default component.exports